import React from "react";
import { AiOutlineCheck } from "react-icons/ai";
import { ImCross } from "react-icons/im";

import { useSelector, useDispatch } from "react-redux";

import PdSelectSearch from "./PdSelectSearch";

import {
  cancelEditMapping,
  updateVatValue,
  updatePdValue,
  updatePdAndVatValue,
  resettingValuesAfterEdit,
  sortVatFields,
  sortPdFields,
} from "../../store/slice/mappingSlice";

const EditMapping = ({
  mappedItem,
  selectDefaultProperty,
  disablePipedriveValue,
}) => {
  const dispatch = useDispatch();

  const storedKey = useSelector((state) => state.mapping.storedKey);
  const editVatValue = useSelector((state) => state.mapping.editVatValue);
  const editPdValue = useSelector((state) => state.mapping.editPdValue);
  const isVatSort = useSelector((state) => state.mapping.isVatSort);
  const isPdSort = useSelector((state) => state.mapping.isPdSort);

  const onUpdateMapping = (value) => {
    if (editVatValue.length === 0 && Object.keys(editPdValue).length > 0) {
      dispatch(updatePdValue(value));
    } else if (
      editVatValue.length > 0 &&
      Object.keys(editPdValue).length === 0
    ) {
      dispatch(updateVatValue(value));
    } else if (editVatValue.length > 0 && Object.keys(editPdValue).length > 0) {
      dispatch(updatePdAndVatValue);
    }
    dispatch(resettingValuesAfterEdit());
    if (isVatSort !== undefined) {
      dispatch(sortVatFields());
    }
    if (isPdSort !== undefined) {
      dispatch(sortPdFields());
    }
  };

  return (
    <>
      <td>
        <p className="my-auto ms-3 vat-label">{mappedItem[0]}</p>
      </td>
      <td>
        <PdSelectSearch
          mappedItem={mappedItem}
          disablePipedriveValue={disablePipedriveValue}
          selectDefaultProperty={selectDefaultProperty}
        />
      </td>
      <td className="p-0 d-flex flex-row justify-content-end actions-column">
        {(storedKey !== editVatValue[0] && editVatValue.length > 0) ||
        (Object.keys(editPdValue).length > 0 &&
          selectDefaultProperty(mappedItem[1]).key !== editPdValue.value) ? (
          <button
            className="add-icon-button"
            onClick={() => onUpdateMapping(mappedItem[0])}
          >
            <AiOutlineCheck className="add-icon" />
          </button>
        ) : (
          ""
        )}
        <button
          className="delete-icon-button"
          onClick={() => {
            dispatch(cancelEditMapping());
          }}
        >
          <ImCross className="delete-icon" />
        </button>
      </td>
    </>
  );
};

export default EditMapping;
